import { render, staticRenderFns } from "./ElevatorLayout.vue?vue&type=template&id=56f031bc&scoped=true&"
import script from "./ElevatorLayout.vue?vue&type=script&lang=js&"
export * from "./ElevatorLayout.vue?vue&type=script&lang=js&"
import style0 from "./ElevatorLayout.vue?vue&type=style&index=0&id=56f031bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f031bc",
  null
  
)

export default component.exports